// extracted by mini-css-extract-plugin
export default {"root":"RlO8U_","searchBoxInputContainer":"Q2YYMa","searchBoxBorderContainer":"oEUJj7","suggestionContainer":"TaFPqR"};